import Vue from 'vue';

Vue.component('role-index', () =>
    import(/* webpackChunkName: 'role-index' */ './role-index.vue'),
);
